export const BASE_URL = "https://app-api-beta.nextlms.us"; 
//export const BASE_URL = "https://app-api-staging.nextlms.us";
//export const BASE_URL = "https://localhost:7101"
export const LOGIN = "/api/auth/Login"; // POST
export const VERIFY_OTP = "/api/auth/verifycode"; //  POST
export const REFRESH_TOKEN = "/api/auth/refreshtoken"; //  POST
export const CHECK_PHONE = "/api/auth/checkphone"; // POST
export const PROFILE = "/api/auth/getprofile"; //  GET
export const SAVE_PROFILE = "/api/auth/saveprofile"; //  POST
export const Languages = "/api/auth/getlanguage"; //  GET
export const CHANGE_Language = "/api/auth/updatelanguage";
export const CAN_SWITCH_ROLE = "/api/auth/canswitch"; // GET
export const GET_USER_ROLES = "/api/auth/getuserroles"; // GET
export const GET_USER_ENTITIES = "/api/auth/getuserentities"; // GET
export const SWITCH_ROLE = "/api/auth/switchrole"; // POST
export const SWITCH_ENTITY = "/api/auth/switchentity"; // POST
export const REPORTING_SERVER_URL = "https://reporting.nextlms.us:4041/"
 
//charts

export const WORKSHOPS_PER_PROVIDER =
  "/api/chartdata/GetNumberOfWorkshopsPerProvider";
export const Attendance_Percentage_ByEmployee =
  "/api/workshop/GetAttendancePercentageByEmployee";
export const WORKSHOPS_STATUS_COUNT = "/api/chartdata/GetWorkshopStatusCount";
export const WORKSHOPS_ATTENDANCE_PER_DEPARTMENT =
  "/api/chartdata/GetWorkshopAttendanceRatioPerDepartment";
export const ACTIVE_WORKSHOPS_PER_MONTH =
  "/api/chartdata/GetActiveWorkshopsForMonth";
export const TRAINER_WORKSHOPS_BY_TOPIC =
  "/api/chartdata/GetTrainerWorkshopsByTopic";
export const TRAINER_WORKSHOPS_BY_STATUS =
  "/api/chartdata/GetTrainerWorkshopsByStatus";
export const VENDOR_WORKSHOPS_BY_LOCATION =
  "/api/chartdata/GetVendorWorkshopsByLocation";
export const VENDOR_COMPANY =
  "/api/chartdata/GetVendorCompanyEngagment";
export const VENDOR_WORKSHOPS_BY_TOPIC =
  "/api/chartdata/GetVendorNumberOfWorkshopsByTopic";
export const TRAINER_WORKSHOPS_BY_TRAINER =
  "/api/chartdata/GetVendorNumberOfWorkshopsByTrainer";
export const TRAINER_WORKSHOPS_BY_LANGUAGE =
  "/api/chartdata/GetVendorNumberOfWorkshopsByLanguage";
export const WORKSHOPS_COMPLETION_RATE =
  "/api/chartdata/GetWorkshopCompletionRatePerVendor";
export const TOPICS_PER_VENDOR = "/api/chartdata/GetTopicsPerVendor";
export const TOP_N_SUBJECS = "/api/chartdata/GetTopNSubjects";
export const MANDAY_PER_VENDOR_AND_LOCATION =
  "/api/chartdata/GetMandaysPerVendorAndLocation";

export const WORKSHOPS_COUNT_PER_VENDOR =
  "/api/chartdata/GetWorkshopsCountPerVendor";

export const MANDAY_PER_VENDOR = "/api/chartdata/GetTotalMandaysPerVendor";

export const MANDAY_PER_VENDOR_AND_MODALITY =
  "/api/chartdata/GetTotalMandaysPerVendorAndModality";

export const MANDAY_PER_VENUE = "/api/chartdata/GetTotalMandaysPerVenue";

export const MANDAY_PER_MONTH_AND_YEAR =
  "/api/chartdata/GetTotalMandaysPerMonthByYear";

//  Countries
export const COUNTRY = "/api/country"; // GET

//  Cities
export const CITY = "/api/city"; // GET

//  Departments
export const DEPARTMENT = "/api/department"; // GET

//  Jobs
export const JOB = "/api/job"; // GET

//  Role
export const ROLE_BASE = "/api/role";
export const ROLE = `${ROLE_BASE}/GetAll`; // GET
export const ROLE_DROP_DOWN = `${ROLE_BASE}/GetRoleDropDown`; // GET
export const ADD_ROLE = `${ROLE_BASE}/AddRole`; // POST
export const EDIt_ROLE = `${ROLE_BASE}/UpdateRole`; // POST

//  Companies

export const COMPANY = "/api/Company"; // GET
export const COMPANY_EMPLOYEES = "/api/company/GetCompanyEmployees"; // GET
export const COMPANY_SETTINGS = COMPANY + "/GetCompanySettings"; // GET

//  Vendors
export const VENDOR = "/api/vendor"; // GET

//  Trainers
export const TRAINER = "/api/trainer"; // GET

//  Modalities
export const MODALITY = "/api/workshop/list"; // GET

// Venues
export const VENUE = "/api/venue"; // GET

// Users
export const GET_USERS = "/GetAllUsers"; // GET
export const CREATE_USER = "/CreateUser"; // POST
export const UPDATE_USER = "/UpdateUser"; // POST
export const GET_CORPORATE_USERS = "/GetAllCorporateUsers"; // GET

// Permissions
export const PERMISSIONS = "/api/permissions"; // GET
export const PERMISSIONList = "/api/permissions/permissionList"; // GET
export const PERMISSIONListUPDATE = "/api/permissions/updatePermission"; // GET
export const PERMISSIONListADD = "/api/permissions/addpermission"; // GET
export const PERMISSIONListDELETE = "/api/permissions/deletePermission"; // GET

// Competencies
export const COMPETENCY = "/api/competency"; // GET

// Import Competencies
export const IMPORT_COMPETENCY = "/api/competency/ImportCompanyCompetenciesAsync"; // POST

// Import Departments
export const IMPORT_DEPARTMENTS = "/api/CompanyDepartments/ImportCompanyDepartmentAsync"; // POST

// Import Competencies
export const IMPORT_JOBS = "/api/CompanyJob/ImportCompanyJobsAsync"; // POST


// Competencies By Role
export const COMPETENCY_By_Role =
  "/api/CompanyCompetencies/GetCompanyCompetenciesByRole"; // GET

// Topics
export const TOPIC = "/api/topic"; // GET

// Workshops
export const WORKSHOP = "/api/workshop"; // GET
export const WORKSHOP_DETAILS = "/api/workshop/details"; // GET - Returns workshop details with correct employeeIds
export const GET_ENROLLMENTS = "/api/enrollment/GetEnrollments"
export const GET_ENROLLMENTS_STATUS = "/api/enrollment/GetEnrollmentStatus"
export const WORKSHOP_ENROLLMENT_DETAILS = (workshopId: string) => `/api/workshop/enrollment/${workshopId}`; // GET
export const CHECK_ENROLLMENT_STATUS = (workshopId: string) => `/api/enrollment/check-enrollment/${workshopId}`; // GET
export const ENROLL_VIA_LINK = "/api/enrollment/enroll-via-link"; // POST

export const RESPOND_ENROLLMENT = "/api/enrollment/RespondToEnrollment"; // POST

// Workshop Photos
export const WORKSHOP_PHOTOS_BASE = "/api/workshopphotos";
export const WORKSHOP_PHOTOS_BY_WORKSHOP = (workshopId: string) => `${WORKSHOP_PHOTOS_BASE}/GetByWorkshopId/${workshopId}`; // GET
export const WORKSHOP_PHOTOS_UPLOAD = `${WORKSHOP_PHOTOS_BASE}/Upload`; // POST
export const WORKSHOP_PHOTOS_DELETE = (photoId: string) => `${WORKSHOP_PHOTOS_BASE}/Delete/${photoId}`; // DELETE
export const WORKSHOP_PHOTOS_GET = (photoId: string) => `${WORKSHOP_PHOTOS_BASE}/Get/${photoId}`; // GET


// Employee Workshops
export const EMPLOYEE_WORKSHOP = "/employeeworkshops"; // GET
export const EMPLOYEE_ENROLL = "/api/enrollment/enrollemployee "; // GET

// Employee grades
export const EMPLOYEES_GRADES = "/api/enrollment/GetGrades"; // GET

// Employee update grade
export const EMPLOYEES_UPDATE_GRADES = "/api/enrollment/UpdateGrades"; // GET

// Workshops group
export const WORKSHOPS_GROUP = "/api/workshopsgroup"; // GET

// Workshops group
export const EMPLOYEE = "/api/employee"; // GET
export const CREATE_EMPLOYEE = "/api/employee/CreateManualEmp"; // POST

export const TEMPLATE_SHEET = "/api/employee/downloadTemplate"; // GET

export const IMPORT_EMPLOYEES = "/api/employee/importEmployees"; // post

export const UPDATE_EMPLOYEES = "/api/employee/UpdateEmployees"; // post

// Workshops group
export const COMPANY_JOB = "/api/CompanyJob"; // GET

// Company department
export const COMPANY_DEPARTMENT = "/api/CompanyDepartments"; // GET

// Company topics
export const COMPANY_TOPIC = "/api/CompanyTopic"; // GET

// Corporate topics
export const CORPORATE_TOPIC = "/api/CorporateTopic"; // GET

// Corporate topics
export const CORPORATE_VENDOR = "/api/corporate/GetVendors"; // GET
export const ADD_CORPORATE_VENDOR = "/api/corporate/AddVendor"; // GET
export const EDIT_CORPORATE_VENDOR = "/api/corporate/EditVendor"; // GET
export const DELETE_CORPORATE_VENDOR = "/api/corporate/RemoveVendor"; // GET

// Company competencies
export const COMPANY_COMPETENCY = "/api/CompanyCompetencies"; // GET

// Corporate competencies
export const CORPORATE_COMPETENCY = "/api/CorporateCompetencies"; // GET

// Company Job Competency
export const COMPANY_JOB_COMPETENCY = "/api/companyjobcompetencies"; // GET

// Workshop Invitations
export const WORKSHOP_INVITATION = "/api/workshopInvitation"; // GET
export const WORKSHOP_INVITATION2 = "/api/workshopinvitation"; // GET

// Employee Competencies
export const EMPLOYEE_COMPETENCIES = "/api/employeecompetencies"; // GET

export const INDUSTRY = "/api/industry"; // GET

export const ENROLLMENT = "/api/enrollment"; // GET
export const GET_ENROLLMENTS_BY_EMPLOYEE = "/api/enrollment/GetEnrollmentsByEmployee"; // GET

export const COMPANY_PROFICIENCY_LEVELS = "/api/companyproficiencylevels"; // GET

export const WORKSHOP_EVALUATION = "/api/workshopevaluation"; // GET

export const WORKSHOP_EVALUATION_QUESTION = "/api/workshopevaluationQuestions"; // GET

export const WORKSHOP_EVALUATION_QUESTION_DIMENSION =
  "/api/workshopevaluationQuestionDimensions"; // GET

export const WORKSHOP_EVALUATION_QUESTION_OPTION =
  "/api/workshopevaluationQuestionOptions"; // GET

export const EMPLOYEE_WORKSHOP_EVALUATION = "/api/employeeWorkshopEvaluation"; // GET

export const VENDOR_ASSESSMENT_DEFINITION = "/api/vendorassessmentdefinition"; // GET

export const VENDOR_ASSESSMENT_QUESTION = "/api/vendorassessmentquestions"; // GET

// Vendor Assessment Questions Export
export const VENDOR_ASSESSMENT_QUESTION_EXPORT_PDF = "/api/vendorassessmentquestions/export-pdf"; // GET
export const VENDOR_ASSESSMENT_QUESTION_EXPORT_EXCEL = "/api/vendorassessmentquestions/export-excel"; // GET

export const VENDOR_ASSESSMENT_QUESTION_OPTION =
  "/api/vendorassessmentquestionoptions"; // GET

export const WORKSHOP_ASSESSMENTS = "/api/workshopassessments"; // GET

export const LANGUAGE = "/api/language"; // GET

export const VENDOR_ASSESSMENT_TYPE = "/api/vendorassessmenttypes"; // GET
export const EMPLOYEE_WORKSHOP_ASSESSMENT = "/api/employeeworkshopassessment"; // GET
export const GET_ASSESSMENT_RESULT = (assessmentDefinitionId: string) => `/api/employeeworkshopassessment/result?assessmentDefinitionId=${assessmentDefinitionId}`; // GET
export const WORKSHOP_SCORE_DATA = "/api/workshopscoredata"; // GET
export const UPDATE_WORKSHOP_SCORE_DATA = "/api/workshopscoredata/update"; // POST

export const WORKSHOP_EVALUATION_DATA = "/api/workshopevaluationdata"; // GET
export const UPDATE_WORKSHOP_EVALUATION_DATA = "/api/workshopevaluationdata/update"; // POST

export const CORPORATE = "/api/corporate"; // GET

export const COMPETENCY_MAPPING = '/api/corporatecompanycompetencymap'

// Reports
export const WORKSHOPS_PER_CLIENT_REPORT = "/api/report/workshops-per-client"; // GET
export const ASSESSMENT_REPORT = "/api/report/assessment-report"; // GET
export const WORKSHOP_PRETEST_GRADES_REPORT = (workshopId: string) => `/api/report/workshop-weak-attendees/${workshopId}`; // GET
export const PRETEST_ANALYSIS_REPORT = (workshopId: string) => `/api/report/pretest-analysis-report/${workshopId}`; // GET
export const WORKSHOP_EXCEL_SUMMARY_REPORT = (workshopId: string) => `/api/report/workshop-excel-summary/${workshopId}`; // GET
export const WORKSHOP_REPORT = (workshopId: string) => `/api/report/workshop-report/${workshopId}`; // GET
export const WORKSHOP_ATTENDEES_CHRONOLOGICAL_REPORT = (workshopId: string, format: string = 'excel') => `/api/report/workshop-attendees-chronological/${workshopId}?format=${format}`; // GET
export const GET_VENDOR_COMPANIES = "/api/vendor/getcompanies"; // GET

// Parameters
export const PARAMETER = "/api/parameter"; // GET, POST, PUT, DELETE

// Certifying Bodies
export const CERTIFYING_BODIES = "/api/certifyingbodies"; // GET, POST, PUT, DELETE

// Certificate Verification
export const VERIFY_CERTIFICATE = (enrollmentId: string) => `/api/certificate/verify/${enrollmentId}`; // GET